<template>
    <div>
        <div
            :id="item.id"
            class="border border-gray-800 rounded-2xl p-4 mb-4 h-[365px] flex flex-col justify-between w-[343px]"
        >
            <div>
                <AppCompareSlider
                    custom-size="h-[197px]"
                    provider="imgProvider"
                    :item="item.compareImages"
                    class="mb-4"
                    img-class="rounded-lg w-full h-[197px]"
                >
                    <template #before-badge>
                        <div
                            class="px-2 py-1 rounded-lg bg-black bg-opacity-60 top-2 left-2 text-gray-100 leading-6 text-body-md absolute"
                        >
                            {{ $t("global_before") }}
                        </div>
                    </template>
                    <template #after-badge>
                        <div
                            class="px-2 py-1 rounded-lg bg-black bg-opacity-60 top-2 right-2 text-gray-100 leading-6 text-body-md absolute"
                        >
                            {{ $t("global_after") }}
                        </div>
                    </template>
                </AppCompareSlider>

                <p class="font-bold text-gray-100">{{ item.title }}</p>
                <p class="text-gray-400 text-body-sm">{{ item.description }}</p>
            </div>
            <div class="flex items-center justify-between mt-4">
                <div class="flex space-x-4 w-full justify-end">
                    <NuxtLinkLocale @click="navigateBtn(item)" :id="item.id" class="block">
                        <AppButton
                            color="brand"
                            size="sm"
                            :id="item.id"
                            :state="item.disabled ? 'disabled' : 'default'"
                        >
                            <div class="flex justify-center space-x-1 items-center">
                                <span>
                                    {{ item.disabled ? $t("global_comingSoon") : $t("global_use") }}
                                </span>
                                <PricingPlanBadge
                                    v-if="
                                        item.type === 'real-estate-hub' &&
                                        !item.disabled &&
                                        userData.is_real_estate_permitted === false
                                    "
                                    plan-name="pro"
                                />
                            </div>
                        </AppButton>
                    </NuxtLinkLocale>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { useUserStore } from "~/store/global/user.store";
const { userData } = storeToRefs(useUserStore());
interface IProps {
    item: ICompareTabGroupItem;
}
const auth = useAuth();
defineProps<IProps>();
const emit = defineEmits(["navigateFunc"]);

const localePath = useLocalePath();

const navigateBtn = (payload: ICompareTabGroupItem) => {
    if (payload.disabled) return;
    if (payload.type !== "real-estate-hub" || userData.value.is_real_estate_permitted || !auth.value)
        navigateTo(localePath(payload.cta.link));
    else emit("navigateFunc");
};
// const showUpgradeModal = ref(true);
</script>
